import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import EventAPI from "../../api/EventApi";

/**
 * The events a host's "Past Events" guest source reads from (GIS-285): the ones
 * they host, the ones they co-host (GIS-222's `coHostIDs`, through the same
 * query the events list uses), and optionally the ones they attended. One entry
 * per event, in that order, as `{ id, data }`.
 */
export async function fetchHostPastEvents(vendorID, { includeAttended = false } = {}) {
  if (!vendorID) return [];
  const events = collection(db, "events");
  const [hosted, coHosted, attended] = await Promise.all([
    getDocs(query(events, where("vendorID", "==", vendorID))),
    EventAPI.getCoHostedEvents(vendorID),
    includeAttended ? getDocs(query(events, where("sitters", "array-contains", vendorID))) : null,
  ]);

  const out = [];
  const seen = new Set();
  const add = (id, data) => {
    if (!id || seen.has(id)) return;
    seen.add(id);
    out.push({ id, data: data || {} });
  };
  hosted.docs.forEach((snap) => add(snap.id, snap.data()));
  (coHosted || []).forEach((event) => add(event.id, event));
  if (attended) attended.docs.forEach((snap) => add(snap.id, snap.data()));
  return out;
}

/** Everyone in those events' eventUsers, one row per user. The first event a user appears in wins. */
export function guestsFromEvents(events) {
  const users = new Map();
  (events || []).forEach(({ data }) => {
    Object.entries(data?.eventUsers || {}).forEach(([userId, userData]) => {
      if (!users.has(userId)) users.set(userId, { id: userId, ...userData });
    });
  });
  return Array.from(users.values());
}
